// extracted by mini-css-extract-plugin
export default {"column":"KanbanColumn_column__RHvtZ","columnTitle":"KanbanColumn_columnTitle__SoXOo","taskList":"KanbanColumn_taskList__-mm9y","addTaskButton":"KanbanColumn_addTaskButton__0s6PF"};